import './wasm_exec.js';

// Might need to move loadWasm to bootstrap.js so that it get loaded only one time
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export async function loadWasm() {
  // Create a new Go object
  const goWasm = new window.Go();
  const result = await WebAssembly.instantiateStreaming(
    // Fetch and instantiate the ruleset-system-calculate-eld-state.wasm file
    fetch('./ruleset-system-calculate-eld-state.wasm'),
    // Provide the import object to Go for communication with JavaScript
    goWasm.importObject,
  );
  // Run the Go program with the WebAssembly instance
  goWasm.run(result.instance);
}

export const wasmCalculateEldState = async (
  inputELDR,
  driverConfiguration,
  stateSnapshot,
  time,
) => {
  try {
    await loadWasm();
    const res = await window.calculateEldState(inputELDR, driverConfiguration, stateSnapshot, time);
    return res;
  } catch (err) {
    console.log(err);
  }
};
